import { KnownHubDetailsDtoType, TowerModelDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { RJSFSchema } from '@rjsf/utils';

// TODO: Revisit manufacturer options once we add more manufacturer types.
// Currently HZDC is used for lockers hubs and Kern for external lockers hubs.
const MANUFACTURER_BY_HUB_TYPE: Record<string, string> = {
  [KnownHubDetailsDtoType.LockersHub]: 'HZDC',
  [KnownHubDetailsDtoType.LockersHubExternal]: 'Kern'
};

export function getManufacturerForHubType(hubType?: KnownHubDetailsDtoType): string | undefined {
  return hubType ? MANUFACTURER_BY_HUB_TYPE[hubType] : undefined;
}

export class HubLayoutFormSchema {
  static FromFormData(
    _towerModels: TowerModelDto[],
    hubType?: KnownHubDetailsDtoType,
    hasDoubleSided?: boolean,
    isSetupComplete?: boolean,
    isExternalSetupLocked?: boolean
  ): RJSFSchema {
    const manufacturer = hubType ? MANUFACTURER_BY_HUB_TYPE[hubType] : undefined;
    const isExternalHub = hubType === KnownHubDetailsDtoType.LockersHubExternal;

    return {
      properties: {
        manufacturer: {
          type: 'string',
          title: 'Manufacturer',
          readOnly: true,
          ...(manufacturer ? { default: manufacturer, enum: [manufacturer] } : { default: '' })
        },
        ...(!isExternalHub && {
          iotHubID: {
            type: 'string',
            title: 'IoT Hub ID',
            maxLength: 128,
            pattern: "^[a-zA-Z0-9:.+%_#*?!(,)=@;$'-]+$",
            ...((isSetupComplete || isExternalSetupLocked) && { readOnly: true })
          }
        }),
        sidesSelection: {
          type: 'string',
          title: 'Sides',
          oneOf: [
            { const: 'single', title: 'Single-Sided Lockers' },
            { const: 'double', title: 'Double-Sided Lockers' }
          ],
          default: 'single',
          ...((isSetupComplete || isExternalSetupLocked) && { readOnly: true })
        },
        towers: {
          type: 'array',
          title: '',
          minItems: 1,
          items: {
            type: 'object',
            properties: {
              model: {
                type: 'string',
                title: 'Model',
                minLength: 1
              },
              inventoryID: {
                type: 'string',
                title: 'Inventory ID',
                minLength: 1
              }
            },
            required: ['model', 'inventoryID']
          }
        },
        ...(hasDoubleSided && {
          frontName: {
            type: 'string',
            title: 'Front name',
            default: 'outside',
            minLength: 1,
            ...(isExternalSetupLocked && { readOnly: true })
          },
          backName: {
            type: 'string',
            title: 'Back name',
            default: 'inside',
            minLength: 1,
            ...(isExternalSetupLocked && { readOnly: true })
          }
        })
      },
      required: [
        'manufacturer',
        ...(!isExternalHub ? ['iotHubID'] : []),
        'sidesSelection',
        'towers',
        ...(hasDoubleSided ? ['frontName', 'backName'] : [])
      ]
    };
  }
}
